import React, { useEffect, useState } from "react";
import { json, Link, useParams } from "react-router-dom";
import projects from "../../../../utils/projects";
import Navbar from "../../../Navbar/Navbar";
import code from "../../../../img/code.svg";
import web from "../../../../img/web_site.svg";
import back from "../../../../img/back.svg";
import "./Project.scss";
const Project = () => {
	const { id } = useParams();
	const [data, setData] = useState(
		projects.find((project) => project.id == id)
	);
	useEffect(() => {
		console.log(projects.find((p) => p.id == id));
	}, [id]);

	return (
		<div>
			<Navbar />
			<div className="project-container">
				<div className="right">
					<h1 className="name_project">{data.name_web}</h1>
					<div className="buttons_project">
						<a className="code" href={data.code} target="_blank">
							<p>Code</p>
							<img src={code} alt="" srcset="" />
						</a>
						<a className="web" href={data.website} target="_blank">
							<p>Website</p>
							<img src={web} alt="" srcset="" />
						</a>
					</div>
					<div className="description">
						<p>{data.description}</p>
					</div>
				</div>
				<div className="left">
					<div className="technologies">
						<h2>Technologies</h2>
						<div className="tags">
							{data.tags.map((tag, index) => (
								<a href={tag.link} target="_blank">
									<div className={`tag  ${tag}`} key={index}>
										<p>{tag.name}</p>
										<img src={tag.url} alt={tag.alt} />
									</div>
								</a>
							))}
						</div>
					</div>
					<img src={data.img} alt="" className="img_project" />
				</div>
			</div>
			<Link to="/projects/" className="button_back">
				<img src={back} alt="" srcset="" />
			</Link>
		</div>
	);
};

export default Project;
